<template>
  <v-app>
    <v-content>
      <v-container color="grey" fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4>
            <v-form @submit.prevent="tryToLogin">
              <v-card class="elevation-12">
                <v-toolbar dark color="primary">
                  <v-toolbar-title>Logowanie</v-toolbar-title>

                  <v-spacer />

                  <v-toolbar-title>{{ applicationTitle }}</v-toolbar-title>
                </v-toolbar>

                <v-alert v-model="showError" class="mt-3 mx-3" type="error" outline>{{ errorMessage }}</v-alert>

                <v-card-text>
                  <v-text-field
                    v-model="login"
                    prepend-icon="person"
                    name="login"
                    label="Login"
                    type="text"
                    placeholder=" "
                  />

                  <v-text-field
                    id="password"
                    v-model="password"
                    prepend-icon="lock"
                    name="password"
                    label="Hasło"
                    hint="Hasło musi składać się z minimum 14 znaków (w tym cyfry, znaku specjalnego, małej oraz wielkiej litery)"
                    placeholder=" "
                    :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                    :type="showPassword ? 'text' : 'password'"
                    @click:append="showPassword = !showPassword"
                  />
                </v-card-text>

                <v-card-actions>
                  <router-link class="ma-2" :to="{ name: 'reset' }">Zapomniałem hasła</router-link>

                  <router-link class="ma-2" :to="{ name: 'resend' }">Wyślij link aktywacyjny</router-link>

                  <v-spacer />

                  <v-btn type="submit" color="primary">Login</v-btn>
                </v-card-actions>
              </v-card>
            </v-form>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import { config } from '@/utils/config';
import { formatError } from '@witkac/kartamiejska-shared';

// @vuese
// Formularz logowania
// @group Auth
export default {
  data() {
    return {
      applicationTitle: config.applicationTitle,
      showPassword: false,
      password: undefined,
      login: undefined,
      showError: false,
      errorMessage: undefined
    };
  },
  watch: {
    errorMessage(val) {
      if (val) {
        this.showError = true;
      }
    },
    showError(val) {
      if (!val) {
        this.errorMessage = undefined;
      }
    }
  },
  methods: {
    // @vuese
    // Metoda próbuje zalogować użytkownika po podanych danych
    async tryToLogin() {
      try {
        const res = await this.$store.dispatch('auth/login', { login: this.login, password: this.password });
        if (res && res.requiresMfa) {
          this.showError = false;
          this.errorMessage = undefined;
          this.$router.push({ name: 'loginMfa' });
          return;
        }
        const profileTarget = res.profile.partner ? 'placeSelect' : 'profile';
        const target = res.hasAllConsents ? profileTarget : 'termsCurrent';
        this.$router.push({ name: target });
      } catch (error) {
        this.errorMessage = formatError(error);
      }
    }
  }
};
</script>
